export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-100 mt-auto">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Left Side: Brand & Copyright */}
          <div className="flex items-center space-x-2">
            <span className="text-gray-400 text-sm">
              &copy; {currentYear}, All rights reserved.
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
